export { GetAnalyticsVars } from 'next-flight-server-reference-proxy-loader?id=7f52fd0dbacb73d2b786852bcc90751a7de3d05d5e&name=GetAnalyticsVars!'